// extracted by mini-css-extract-plugin
module.exports = {"BaseTable":"styles_BaseTable__PVJBn"};